import * as i2 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i0 from '@angular/core';
import { Component, Input, ViewChild, EventEmitter, Output, HostListener, NgModule } from '@angular/core';
import * as i3 from 'se-fe-button';
import { SeFeButtonModule } from 'se-fe-button';
import * as i2$1 from 'se-fe-icon';
import { SeFeIconModule, seFeIconImageMultiThin } from 'se-fe-icon';
import * as i4 from 'ngx-image-cropper';
import { ImageCropperModule } from 'ngx-image-cropper';
import { __awaiter } from 'tslib';
import * as i1$1 from 'se-fe-attachment-service';
import { SeFeAttachment } from 'se-fe-attachment-service';
import * as i1 from 'se-fe-spinner';
import { SeFeSpinnerModule } from 'se-fe-spinner';

class SeFeSmallButtonComponent {
    constructor(ref, render) {
        this.ref = ref;
        this.render = render;
        this.loading = false;
        this.disabled = false;
    }
    ngAfterViewInit() {
        this.styleFocusedBorder();
    }
    click(event) {
        if (this.clickDisabled()) {
            this.preventClickAction(event);
        }
    }
    preventClickAction(event) {
        event.preventDefault();
        event.stopPropagation();
    }
    clickDisabled() {
        return this.disabled || this.loading;
    }
    styleFocusedBorder() {
        const btn = this.buttonEle.nativeElement;
        const height = btn.offsetHeight + 8;
        const width = btn.offsetWidth + 8;
        this.render.setStyle(this.borderEle.nativeElement, 'height', `${height}px`);
        this.render.setStyle(this.borderEle.nativeElement, 'width', `${width}px`);
    }
}
SeFeSmallButtonComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFeSmallButtonComponent, deps: [{ token: i0.ElementRef }, { token: i0.Renderer2 }], target: i0.ɵɵFactoryTarget.Component });
SeFeSmallButtonComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.17", type: SeFeSmallButtonComponent, selector: "se-fe-small-button", inputs: { loading: "loading", disabled: "disabled" }, host: { classAttribute: "se-fe-small-button" }, viewQueries: [{ propertyName: "borderEle", first: true, predicate: ["borderEle"], descendants: true }, { propertyName: "buttonEle", first: true, predicate: ["buttonEle"], descendants: true }], ngImport: i0, template: "<button #buttonEle type=\"button\"\n        class=\"se-fe-small-button__button small-button\"\n        [ngClass]=\"{'small-button--loading': loading}\"\n        [disabled]=\"disabled\">\n  <span class=\"small-button__text\"><ng-content></ng-content></span>\n  <se-fe-spinner class=\"small-button__spinner\"\n    *ngIf=\"loading\"\n    [seFeDataSize]=\"500\"\n    [seFeDataCenter]=\"true\"\n    [seFeDataInverted]=\"true\">\n  </se-fe-spinner>\n</button>\n<span #borderEle class=\"se-fe-small-button__border--active active-border\"></span>\n", styles: [".light-blue-background{background-color:#00668f29}:host{position:relative;font:600 inherit \"Open Sans\",sans-serif;box-sizing:border-box}.small-button{cursor:pointer;position:relative;padding:4px;border-radius:4px;font-size:inherit;background:none;border:0;color:#00668f;z-index:1}.small-button__text{text-align:center}.small-button:disabled,.small-button[aria-disabled=true]{color:#c1cace;background:transparent;cursor:unset}.small-button:hover{background:rgba(0,102,143,.04)}.small-button:focus{background:rgba(0,102,143,.12)}.small-button:active{background:rgba(0,102,143,.16)}.small-button:active+.active-border{display:inline}.small-button--loading{background-color:#00668f1f}.small-button--loading .small-button__spinner.se-fe-spinner--center{display:inline-block}.small-button--loading .small-button__text{visibility:hidden}.small-button__spinner.se-fe-spinner--center{display:none;top:1px;position:absolute;left:0;right:0;margin-left:auto;margin-right:auto}.active-border{box-sizing:border-box;position:absolute;left:-4px;top:-4px;background:#fff;border:2px solid #00668f;border-radius:4px;display:none}\n"], components: [{ type: i1.SeFeSpinnerComponent, selector: "se-fe-spinner", inputs: ["seFeDataSize", "seFeDataInverted", "seFeDataCenter", "seFeDataAriaLabel"] }], directives: [{ type: i2.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFeSmallButtonComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'se-fe-small-button',
                    templateUrl: './se-fe-small-button.component.html',
                    styleUrls: ['./se-fe-small-button.component.scss'],
                    host: { class: 'se-fe-small-button' },
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i0.Renderer2 }]; }, propDecorators: { loading: [{
                type: Input
            }], disabled: [{
                type: Input
            }], borderEle: [{
                type: ViewChild,
                args: ['borderEle']
            }], buttonEle: [{
                type: ViewChild,
                args: ['buttonEle']
            }] } });

var SeFeImageTypes;
(function (SeFeImageTypes) {
    SeFeImageTypes["gif"] = "image/gif";
    SeFeImageTypes["jpg"] = "image/jpeg";
    SeFeImageTypes["png"] = "image/png";
    SeFeImageTypes["jpeg"] = "image/jpeg";
})(SeFeImageTypes || (SeFeImageTypes = {}));
class SeFeImageUploaderComponent {
    constructor(attachServe) {
        this.attachServe = attachServe;
        this.centered = false;
        this.circular = false;
        this.crop = false; //currently only supports base64 output
        this.cropFormat = 'auto';
        this.output = 'attachment'; // attachment, base64
        this.uploadSuccess = new EventEmitter();
        this.uploadFailed = new EventEmitter();
        this.uploadCleared = new EventEmitter();
        this.uploadedImage = null; // INITIAL uploaded image
        this.attachment = null; // Uploaded image RESULT
        this.isLoading = false;
        this.finishedLoading = false;
        // Image Cropper specific stuff
        this.croppedImage = '';
        this.imageBase64 = '';
        this.fileUploadAttempted = false;
    }
    ngOnInit() {
        this.aspectRatio = this.thousandths(this.imgWidth / this.imgHeight);
    }
    altText() {
        return this.attachment ? `${this.attachment.filename} preview` : 'Image preview';
    }
    imageChange(event) {
        this.finishedLoading = false;
        const files = this.isDragEvent(event) ?
            event.dataTransfer.files : event.target.files;
        if (files.length === 0)
            return;
        if (!this.isAcceptableFormat(files[0]))
            return;
        this.file = files[0];
        if (this.crop) {
            return this.toBase64(this.file).then(fileString => {
                this.imageCropFormat = this.fileCropFormat(this.file);
                this.imageBase64 = fileString;
                this.fileUploadAttempted = true;
                this.finishedLoading = true;
            });
        }
        if (this.output === 'base64') {
            this.fileUploadAttempted = true;
            return this.toBase64(this.file).then(fileString => {
                this.file['base64'] = fileString.split(',')[1]; //removes filetype and 'base64' from string
                this.uploadSuccess.emit(this.file);
            });
        }
        return this.uploadFile(new SeFeAttachment(this.file));
    }
    toBase64(file) {
        return __awaiter(this, void 0, void 0, function* () {
            const result = yield new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onload = () => {
                    this.imgUrl = reader.result;
                    resolve(reader.result);
                };
                reader.onerror = () => {
                    reject(reader.result);
                };
                this.isLoading = false;
                this.finishedLoading = true;
                reader.readAsDataURL(file);
            });
            return result;
        });
    }
    retryImageUpload() {
        if (!this.fileInputHasValue())
            return;
        return this.uploadFile(new SeFeAttachment(this.fileInput.nativeElement.files[0]));
    }
    imageUploadAttempted() {
        return (!this.isNullOrUndefined(this.attachment) || !this.isNullOrUndefined(this.file)) &&
            this.fileUploadAttempted === true;
    }
    reset() {
        this.attachment = null;
        this.file = null;
        // so that if same file is chosen again, it will still trigger a change event
        this.fileInput.nativeElement.value = '';
        this.fileInput.nativeElement.files = null;
        this.finishedLoading = false;
        this.imageBase64 = null;
        this.uploadCleared.emit();
    }
    imageCropped(event) {
        this.croppedImage = event.base64;
        this.file['base64'] = this.croppedImage.split(',')[1];
        this.uploadSuccess.emit(this.file);
    }
    loadImageFailed() {
        this.uploadFailed.emit('Invalid Image');
        this.reset();
    }
    onDragOver(event) {
        event.preventDefault();
        event.stopPropagation();
    }
    onMouseOver(event) {
        event.preventDefault();
        event.stopPropagation();
    }
    onMouseLeave(event) {
        event.preventDefault();
        event.stopPropagation();
    }
    onDrop(event) {
        return __awaiter(this, void 0, void 0, function* () {
            event.preventDefault();
            event.stopPropagation();
            this.imageChange(event);
        });
    }
    fileCropFormat(file) {
        if (this.cropFormat !== 'auto') {
            return this.cropFormat;
        }
        else if (file.type.toLowerCase().includes('png')) {
            return 'png';
        }
        else {
            return 'jpeg';
        }
    }
    thousandths(float) {
        return Math.round(float * 1000) / 1000;
    }
    isAcceptableFormat(file) {
        /**
         * The file input accept takes in a list of allowed file extensions or MIME types,
         * so to get parity for drag-n-drop, we check the same
         */
        if (!this.acceptFormat)
            return true;
        const acceptFormats = this.acceptFormat.split(',').map(f => f.trim());
        const formatMatch = acceptFormats.find(acceptFormat => {
            if (acceptFormat.startsWith('.')) {
                return file.name.endsWith(acceptFormat);
            }
            else {
                const acceptFormatRegex = new RegExp(acceptFormat.replace('*', '.\*'));
                return acceptFormatRegex.test(file.type);
            }
        });
        return !!formatMatch;
    }
    isDragEvent(event) {
        return event.dataTransfer !== undefined;
    }
    isNullOrUndefined(value) {
        return value === undefined || value === null;
    }
    uploadFile(attachment) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                this.isLoading = true;
                this.attachment = yield this.attachServe.upload(attachment);
                this.imgUrl = attachment.url;
                this.finishedLoading = true;
                this.uploadSuccess.emit(this.attachment);
            }
            catch (err) {
                this.uploadFailed.emit(err);
                console.error(err);
            }
            finally {
                this.isLoading = false;
                this.fileUploadAttempted = true;
            }
        });
    }
    fileInputHasValue() {
        return !this.isNullOrUndefined(this.fileInput) &&
            !this.isNullOrUndefined(this.fileInput.nativeElement.files) &&
            this.fileInput.nativeElement.files.length > 0;
    }
}
SeFeImageUploaderComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFeImageUploaderComponent, deps: [{ token: i1$1.SeFeAttachmentService }], target: i0.ɵɵFactoryTarget.Component });
SeFeImageUploaderComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.17", type: SeFeImageUploaderComponent, selector: "se-fe-image-uploader", inputs: { centered: ["seFeDataCentered", "centered"], circular: ["seFeDataCircular", "circular"], crop: ["seFeDataCrop", "crop"], cropFormat: ["seFeDataCropFormat", "cropFormat"], cropHeight: ["seFeDataCropHeight", "cropHeight"], cropWidth: ["seFeDataCropWidth", "cropWidth"], output: ["seFeDataOutput", "output"], acceptFormat: ["seFeAcceptFormat", "acceptFormat"] }, outputs: { uploadSuccess: "uploadSuccess", uploadFailed: "uploadFailed", uploadCleared: "uploadCleared" }, host: { listeners: { "dragover": "onDragOver($event)", "mouseenter": "onMouseOver($event)", "mouseleave": "onMouseLeave($event)", "drop": "onDrop($event)" }, classAttribute: "se-fe-image-uploader" }, viewQueries: [{ propertyName: "deleteBtn", first: true, predicate: ["deleteBtn"], descendants: true }, { propertyName: "fileInput", first: true, predicate: ["fileInput"], descendants: true }], ngImport: i0, template: "<div class=\"se-fe-image-uploader__img-container image-container\" [ngClass]=\"{ 'centered' : centered }\">\n  <div class=\"image-container__placeholder image-placeholder\" *ngIf=\"!imageUploadAttempted()\">\n    <se-fe-icon *ngIf=\"!finishedLoading\" class=\"image-placeholder__icon\"\n                seFeDataName=\"image_multi_thin\"\n                seFeDataSize=\"900\"\n                seFeDataColor=\"primary\">\n    </se-fe-icon>\n    <span class=\"clearfix\"></span>\n    <se-fe-button *ngIf=\"!finishedLoading\"\n                  class=\"image-placeholder__upload-button\"\n                  [seFeDataEmphasis]=\"'high'\"\n                  [seFeDataIsLoading]=\"isLoading\"\n                  (click)=\"fileInput.click()\">CHOOSE IMAGE\n    </se-fe-button>\n    <span class=\"clearfix\"></span>\n    <span class=\"image-placeholder__drop-text\">or drop image to upload</span>\n  </div>\n  <image-cropper *ngIf=\"crop && finishedLoading\"\n    [imageBase64]=\"imageBase64\"\n    [maintainAspectRatio]=\"true\"\n    [aspectRatio]=\"1 / 1\"\n    [roundCropper]=\"circular\"\n    [format]=\"imageCropFormat\"\n    onlyScaleDown=\"true\"\n    [resizeToHeight]=\"cropHeight\"\n    [resizeToWidth]=\"cropWidth\"\n    (loadImageFailed)=\"loadImageFailed()\"\n    (imageCropped)=\"imageCropped($event)\"\n  ></image-cropper>\n  <img class=\"image-container__img image-preview\" *ngIf=\"imgUrl && finishedLoading && !crop\"\n       src=\"{{ imgUrl }}\" width=240 [alt]=\"altText()\"\n       [ngClass]=\"{ 'circular' : circular}\">\n  <input #fileInput class=\"image-container__file-input\"\n         type=\"file\"\n         [accept]=\"acceptFormat\"\n         (change)=\"imageChange($event)\"/>\n</div>\n<div class=\"se-fe-image-uploader__bottom-content se-fe-image-footer\"\n  [ngClass]=\"{ 'centered' : centered }\">\n  <span class=\"clearfix upload-instructions\">\n    For best results, upload a JPG or PNG file format, no smaller than 400x400 pixels or 20KB\n  </span>\n  <div class=\"se-fe-image-footer__actions post-upload-actions\" *ngIf=\"imageUploadAttempted()\">\n    <se-fe-small-button *ngIf=\"this.attachment\" (click)=\"retryImageUpload()\"\n                        [loading]=\"isLoading\" class=\"post-upload-button\">Retry\n    </se-fe-small-button>\n    <se-fe-small-button [loading]=\"isLoading\" class=\"post-upload-button\" (click)=\"reset()\">Reset</se-fe-small-button>\n  </div>\n</div>\n", styles: [".clearfix:after{display:table;clear:both;content:\"\"}:host(.se-fe-image-uploader){display:block;box-sizing:border-box;font:normal 400 calc(var(--se-rem, 1rem) * 1)/1.4286 \"Open Sans\",sans-serif}.se-fe-image-uploader__img-container{border-radius:4px;border:#c1cace 1px dashed}.se-fe-image-uploader__upload-button{margin-top:12px}.se-fe-image-uploader__bottom-content{width:inherit;font:normal 400 calc(var(--se-rem, 1rem) * .7142857143)/1.4286 \"Open Sans\",sans-serif;margin-top:4px;padding:2px}.image-container{position:relative;box-sizing:border-box;width:306px;height:248px}.image-container__img,.image-container__placeholder{left:0;right:0;margin:auto;position:absolute;top:0;bottom:0;height:140px;width:250px;object-fit:cover}.image-container__file-input{display:none}.circular{left:0;right:0;margin:auto;position:absolute;top:0;bottom:0;height:200px;width:200px;object-fit:cover;border-radius:50%}.centered{margin-left:auto;margin-right:auto}.ngx-ic-source-image{margin:auto}.image-placeholder{display:flex;flex-direction:column;align-items:center}.image-placeholder__icon{color:#c1cace;margin-bottom:6px;fill:currentColor}.image-placeholder__upload-button{margin-bottom:6px}.image-placeholder__drop-text{font-size:calc(var(--se-rem, 1rem) * .8571428571);color:#68767f}.se-fe-image-footer{width:306px}.se-fe-image-footer .post-upload-actions{display:flex;flex-direction:row}.se-fe-image-footer .post-upload-actions__retry{font-size:12px}.se-fe-image-footer .post-upload-actions .post-upload-button{display:inline-block;float:left;margin-right:2px}.se-fe-image-footer .post-upload-actions .post-upload-button:last-child{margin-right:0}.upload-instructions{color:#90a0a7}\n"], components: [{ type: i2$1.SeFeIconComponent, selector: "se-fe-icon", inputs: ["seFeDataAriaLabel", "seFeDataSize", "seFeDataColor", "seFeDataName", "seFeDataMargin"] }, { type: i3.SeFeButtonComponent, selector: "se-fe-button", inputs: ["seFeDataIsDisabled", "seFeDataEmphasis", "seFeDataIsLoading", "seFeDataSnug", "seFeDataFullWidth", "seFeDataType", "seFeDataLoadingLabel"] }, { type: i4.ImageCropperComponent, selector: "image-cropper", inputs: ["format", "transform", "maintainAspectRatio", "aspectRatio", "resizeToWidth", "resizeToHeight", "cropperMinWidth", "cropperMinHeight", "cropperMaxHeight", "cropperMaxWidth", "cropperStaticWidth", "cropperStaticHeight", "canvasRotation", "initialStepSize", "roundCropper", "onlyScaleDown", "imageQuality", "autoCrop", "backgroundColor", "containWithinAspectRatio", "hideResizeSquares", "cropper", "alignImage", "disabled", "imageChangedEvent", "imageURL", "imageBase64", "imageFile"], outputs: ["imageCropped", "startCropImage", "imageLoaded", "cropperReady", "loadImageFailed"] }, { type: SeFeSmallButtonComponent, selector: "se-fe-small-button", inputs: ["loading", "disabled"] }], directives: [{ type: i2.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFeImageUploaderComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'se-fe-image-uploader',
                    templateUrl: './se-fe-image-uploader.component.html',
                    styleUrls: ['./se-fe-image-uploader.component.scss'],
                    host: { class: 'se-fe-image-uploader' },
                }]
        }], ctorParameters: function () { return [{ type: i1$1.SeFeAttachmentService }]; }, propDecorators: { centered: [{
                type: Input,
                args: ['seFeDataCentered']
            }], circular: [{
                type: Input,
                args: ['seFeDataCircular']
            }], crop: [{
                type: Input,
                args: ['seFeDataCrop']
            }], cropFormat: [{
                type: Input,
                args: ['seFeDataCropFormat']
            }], cropHeight: [{
                type: Input,
                args: ['seFeDataCropHeight']
            }], cropWidth: [{
                type: Input,
                args: ['seFeDataCropWidth']
            }], output: [{
                type: Input,
                args: ['seFeDataOutput']
            }], acceptFormat: [{
                type: Input,
                args: ['seFeAcceptFormat']
            }], uploadSuccess: [{
                type: Output
            }], uploadFailed: [{
                type: Output
            }], uploadCleared: [{
                type: Output
            }], deleteBtn: [{
                type: ViewChild,
                args: ['deleteBtn']
            }], fileInput: [{
                type: ViewChild,
                args: ['fileInput']
            }], onDragOver: [{
                type: HostListener,
                args: ['dragover', ['$event']]
            }], onMouseOver: [{
                type: HostListener,
                args: ['mouseenter', ['$event']]
            }], onMouseLeave: [{
                type: HostListener,
                args: ['mouseleave', ['$event']]
            }], onDrop: [{
                type: HostListener,
                args: ['drop', ['$event']]
            }] } });

class SeFeImageUploaderModule {
    static forRoot(environment) {
        return {
            ngModule: SeFeImageUploaderModule,
            providers: [
                { provide: 'env', useValue: environment },
            ],
        };
    }
}
SeFeImageUploaderModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFeImageUploaderModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
SeFeImageUploaderModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFeImageUploaderModule, declarations: [SeFeImageUploaderComponent, SeFeSmallButtonComponent], imports: [CommonModule,
        ImageCropperModule,
        SeFeButtonModule, i2$1.SeFeIconModule, SeFeSpinnerModule], exports: [SeFeImageUploaderComponent, SeFeSmallButtonComponent] });
SeFeImageUploaderModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFeImageUploaderModule, imports: [[
            CommonModule,
            ImageCropperModule,
            SeFeButtonModule,
            SeFeIconModule.include([
                seFeIconImageMultiThin,
            ]),
            SeFeSpinnerModule,
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFeImageUploaderModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [SeFeImageUploaderComponent, SeFeSmallButtonComponent],
                    imports: [
                        CommonModule,
                        ImageCropperModule,
                        SeFeButtonModule,
                        SeFeIconModule.include([
                            seFeIconImageMultiThin,
                        ]),
                        SeFeSpinnerModule,
                    ],
                    exports: [SeFeImageUploaderComponent, SeFeSmallButtonComponent],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { SeFeImageTypes, SeFeImageUploaderComponent, SeFeImageUploaderModule, SeFeSmallButtonComponent };
